import { userServiceApi } from "../../api";
import { UserFindByEmail } from "../types/user";

type FindUserRequest = {
  email: string;
  companyIds: string[];
};

type FindUserResponse = UserFindByEmail;

export const findUser = ({
  email,
  companyIds,
}: FindUserRequest): Promise<FindUserResponse> => {
  return userServiceApi
    .post<FindUserResponse>("/api/v1/users/", { email, companyIds })
    .then((r) => r.data);
};
